import { OrderFilter } from '@/types/orders.type';

export const getStagesByFilter = (filter: OrderFilter) => {
  switch (filter) {
    case OrderFilter.TODAY:
      return [
        {
          $project: {
            label: { $toString: '$createdAt' },
            sales: { $toDouble: '$summary.total' }, // Project the total sales
          },
        },
      ];
    case OrderFilter.THIS_WEEK:
      return [
        {
          $project: {
            sales: { $toDouble: '$summary.total' },
            day: { $dayOfMonth: '$createdAt' },
            month: { $month: '$createdAt' },
            year: { $year: '$createdAt' },
          },
        },
        {
          $group: {
            _id: {
              day: '$day',
              month: '$month',
              year: '$year',
            },
            totalSales: { $sum: '$sales' },
          },
        },
        {
          $project: {
            label: {
              $concat: [
                { $toString: '$_id.year' },
                '-',
                {
                  $cond: {
                    if: { $lt: ['$_id.month', 10] }, // Check if the month is single-digit
                    then: { $concat: ['0', { $toString: '$_id.month' }] }, // Add leading zero
                    else: { $toString: '$_id.month' }, // Keep as-is
                  },
                },
                '-',
                {
                  $cond: {
                    if: { $lt: ['$_id.day', 10] }, // Check if the day is single-digit
                    then: { $concat: ['0', { $toString: '$_id.day' }] }, // Add leading zero
                    else: { $toString: '$_id.day' }, // Keep as-is
                  },
                },
              ],
            },
            sales: '$totalSales',
          },
        },
        {
          $sort: { '_id.year': 1, '_id.month': 1, '_id.day': 1 },
        },
      ];

    case OrderFilter.THIS_MONTH:
      return [
        {
          $project: {
            sales: { $toDouble: '$summary.total' },
            day: { $dayOfMonth: '$createdAt' },
            month: { $month: '$createdAt' },
            year: { $year: '$createdAt' },
          },
        },
        {
          $group: {
            _id: {
              day: '$day', // Group by day within the month
              month: '$month',
              year: '$year',
            },
            totalSales: { $sum: '$sales' }, // Sum the sales for each day
          },
        },
        {
          $project: {
            label: {
              $concat: [
                { $toString: '$_id.year' },
                '-',
                {
                  $cond: {
                    if: { $lt: ['$_id.month', 10] }, // Check if the month is single-digit
                    then: { $concat: ['0', { $toString: '$_id.month' }] }, // Add leading zero
                    else: { $toString: '$_id.month' }, // Keep as-is
                  },
                },
                '-',
                {
                  $cond: {
                    if: { $lt: ['$_id.day', 10] }, // Check if the day is single-digit
                    then: { $concat: ['0', { $toString: '$_id.day' }] }, // Add leading zero
                    else: { $toString: '$_id.day' }, // Keep as-is
                  },
                },
              ],
            },
            sales: '$totalSales',
          },
        },
        {
          $sort: { '_id.year': 1, '_id.month': 1, '_id.day': 1 },
        },
      ];
    case OrderFilter.THIS_YEAR:
      return [
        {
          $project: {
            sales: { $toDouble: '$summary.total' },
            month: { $month: '$createdAt' },
            year: { $year: '$createdAt' },
          },
        },
        {
          $group: {
            _id: {
              month: '$month',
              year: '$year',
            },
            totalSales: { $sum: '$sales' },
          },
        },
        {
          $project: {
            label: {
              $concat: [
                { $toString: '$_id.year' },
                '-',
                {
                  $cond: {
                    if: { $lt: ['$_id.month', 10] },
                    then: { $concat: ['0', { $toString: '$_id.month' }] },
                    else: { $toString: '$_id.month' },
                  },
                },
              ],
            },
            sales: '$totalSales',
          },
        },
        {
          $sort: { '_id.year': 1, '_id.month': 1 },
        },
      ];
    default:
      return [
        {
          $project: {
            sales: { $toDouble: '$summary.total' },
            hour: { $hour: '$createdAt' },
          },
        },
        {
          $group: {
            _id: '$hour',
            totalSales: { $sum: '$sales' },
          },
        },
        {
          $project: {
            label: { $toString: '$_id' },
            sales: '$totalSales',
          },
        },
        {
          $sort: { _id: 1 }, // Sort by hour
        },
      ];
  }
};
